import {
  userConstants
} from '../_constants';

export default function users(state = {}, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        ...state,
        addUserSuccess: false,
        loading: false,
      };
    case userConstants.LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case userConstants.GET_GETALLMESSAGETICKET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userConstants.GET_GETALLMESSAGETICKET_LIST_SUCCESS:
      return {
        ...state,

        loading: false,
        getAllTicketList: action?.user,
      };
    case userConstants.GET_GETALLMESSAGETICKET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //change password
    case userConstants.CHANGEADMIN_PASS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userConstants.CHANGEADMIN_PASS_SUCCESS:
      return {
        ...state,
        addPasswordSuccess: false,
        loading: false,
      };
    case userConstants.CHANGEADMIN_PASS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    //get
    case userConstants.GET_LOGINHISTORY_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userConstants.GET_LOGINHISTORY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loginHistoryList: action?.user
      };
    case userConstants.GET_LOGINHISTORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case userConstants.GET_SWAPPING_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userConstants.GET_SWAPPING_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        swappingList: action?.user?.data
      };
    case userConstants.GET_SWAPPING_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case userConstants.GET_MERCHANT_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userConstants.GET_MERCHANT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        merchantList: action?.user?.data
      };
    case userConstants.GET_MERCHANT_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case userConstants.GET_NOTIFICATION_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userConstants.GET_NOTIFICATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        notificationList: action?.user?.data
      };
    case userConstants.GET_NOTIFICATION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };


    case userConstants.GET_MERCHANT_REQUEST_DET_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userConstants.GET_MERCHANT_REQUEST_DET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        merchantReqList: action?.user?.data
      };
    case userConstants.GET_MERCHANT_REQUEST_DET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case userConstants.GET_SWAPPINGDETAIL_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userConstants.GET_SWAPPINGDETAIL_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        swappingDetailsList: action?.user?.data
      };
    case userConstants.GET_SWAPPINGDETAIL_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

      case userConstants.GET_PROFILE_LIST_REQUEST:
        return {
          ...state,
          loading: true
        };
      case userConstants.GET_PROFILE_LIST_SUCCESS:
        return {
          ...state,
          loading: false,
          profileList: action?.user?.data
        };
      case userConstants.GET_PROFILE_LIST_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.error
        };

    default:
      return state
  }
}